import { useCompanyValues } from '@/providers';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { EXTERNAL_SIDEBAR_LOGOS } from './constants';

type ExternalSidebarLogoProps = {
  className?: string;
};

export const ExternalSidebarLogo: FC<ExternalSidebarLogoProps> = ({ className }) => {
  const { company } = useCompanyValues();

  return (
    <header className={twMerge('flex items-center overflow-hidden ps-1', className)}>
      {EXTERNAL_SIDEBAR_LOGOS[company]}
    </header>
  );
};

type ExternalSidebarTaglineProps = {
  className?: string;
};

export const ExternalSidebarTagline: FC<ExternalSidebarTaglineProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <p className={twMerge('mb-4 text-nowrap border-b border-brand-200 pb-4 ps-1 text-xs font-semibold text-tertiary-hover', className)}>
      {t('home:poweredByAudiencerate')}
    </p>
  );
};
